import { NavLink, useLocation } from "react-router-dom";

export type LinkSidePannelMenuProps = {
    menuIndex: number;
    menuPathUrl: string;
    menuLabel: string;
    iconName?: string;
    disabled?: boolean;
};

export default function LinkSidePannelMenu({
    menuIndex,
    menuPathUrl,
    menuLabel,
    iconName,
    disabled,
  }: LinkSidePannelMenuProps) {
    const currentLocation = useLocation();
    let menuClassName = "lateralnav--item";
    if(currentLocation.pathname === menuPathUrl) {
        menuClassName += " active";

        console.log('currentLocation.pathname', currentLocation.pathname)
        console.log('menuPathUrl', menuPathUrl)
        console.log("is active", currentLocation.pathname, currentLocation.pathname === menuPathUrl)
    }

    

    return (
        <li className={menuClassName}>
            {!disabled&&<NavLink to={menuPathUrl}>
                {iconName && <i className={iconName + " fushia sc-appear-fromleft isreveal"} />}
                <p className={"sc-appear-fromleft delay-" + menuIndex + " isreveal"}>{menuLabel}</p>
            </NavLink>}
            {disabled&&
            <>
                <a href="#" onClick={(e) => {e.preventDefault();}} className="not-allowed">
                    <p className={"sc-appear-fromleft delay-" + menuIndex + " isreveal"}>{menuLabel}</p>
                </a> 
            </>}
        </li>
    )
  }